import { gql } from "@stadium/services/apollo-client";
import { PRODUCT_SEARCH_BASICS_DETAILS } from "@graphql/fragments/product/product-search-basic-details";

export const fetchAdditionalProductsBasicDetailItems = gql`
  query ProductsAdditionalList(
    $storeId: Int!
    $countryCode: String!
    $taxonIds: [Int!]
    $allMenuTaxonIds: [Int!]
    $brandId: Int
    $perPage: Int
    $productId: Int
    $skipAggregations: Boolean
    $sortBy: String
    $skipWarehouse: Boolean!
    $hideMoreFromThisBrand: Boolean!
    $hideYouMightAlsoLike: Boolean!
    $storeUpcharge: Float
    $withSwag: Boolean
    $storeUpdatedAt: String
    $designedStoreIds: [Int!]
    $showVariantsAsProducts: Boolean
    $globalZone: Boolean
    $bulkAvailable: Boolean
    $intent: String
    $optimizedSearch: Boolean
    $excludeByoProducts: Boolean
    $excludeTierPricing: Boolean
    $priceKeys: [String!]
    $currentStoreId: Int
    $includeProductVariants: Boolean = false
  ) @api(name: "search") {
    recommendedProducts: baseSearch(
      perPage: $perPage
      storeId: $storeId
      countryCode: $countryCode
      taxonIds: $taxonIds
      productId: $productId
      skipAggregations: $skipAggregations
      sortBy: $sortBy
      skipWarehouse: $skipWarehouse
      storeUpcharge: $storeUpcharge
      withSwag: $withSwag
      storeUpdatedAt: $storeUpdatedAt
      designedStoreIds: $designedStoreIds
      showVariantsAsProducts: $showVariantsAsProducts
      globalZone: $globalZone
      bulkAvailable: $bulkAvailable
      intent: $intent
      optimizedSearch: $optimizedSearch
      excludeByoProducts: $excludeByoProducts
      excludeTierPricing: $excludeTierPricing
      priceKeys: $priceKeys
      currentStoreId: $currentStoreId
    ) @skip(if: $hideYouMightAlsoLike) {
      total
      products {
        ...ProductSearchBasicDetails
      }
    }
    productsFromBrand: baseSearch(
      perPage: $perPage
      storeId: $storeId
      countryCode: $countryCode
      taxonIds: $allMenuTaxonIds
      productId: $productId
      brandId: $brandId
      skipAggregations: $skipAggregations
      sortBy: $sortBy
      skipWarehouse: $skipWarehouse
      storeUpcharge: $storeUpcharge
      withSwag: $withSwag
      storeUpdatedAt: $storeUpdatedAt
      designedStoreIds: $designedStoreIds
      showVariantsAsProducts: $showVariantsAsProducts
      globalZone: $globalZone
      bulkAvailable: $bulkAvailable
      intent: $intent
      optimizedSearch: $optimizedSearch
      excludeByoProducts: $excludeByoProducts
      excludeTierPricing: $excludeTierPricing
      priceKeys: $priceKeys
    ) @skip(if: $hideMoreFromThisBrand) {
      total
      products {
        ...ProductSearchBasicDetails
      }
    }
  }
  ${PRODUCT_SEARCH_BASICS_DETAILS}
`;
